type Task<T> = (value: T) => Promise<T>;

export enum TaskListResultStatus {
    Completed,
    Canceled
}

export interface TaskListResult<T> {
    status: TaskListResultStatus,
    result?: T
}

// A task list is a list of async functions that will be executed in some order.
export class TaskList<T> {
    private isCanceled: boolean = false;
    private tasks: Task<T>[];

    constructor(tasks: Task<T>[]) {
        this.tasks = tasks;
    }

    // Executes a task list sequentially. Each task receives as input the result of the previous task in the list.
    // The output of executing the list sequentially is the result of the last task in the list.
    // If the TaskList is canceled before all tasks finish executing, we return the Canceled status.
    public async ExecuteTaskListSequentially(): Promise<TaskListResult<T>> {
        if (this.isCanceled)
            return  { status: TaskListResultStatus.Canceled };

        let result: T = null;
        for (let task of this.tasks) {
            result = await task(result);

            if (this.isCanceled)
                return  { status: TaskListResultStatus.Canceled };
        }
    
        return { status: TaskListResultStatus.Completed, result: result };
    }

    public Cancel() {
        this.isCanceled = true;
    }
}